var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelColor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 40C33.2037 40 28.8241 38.963 24.3611 36.8889C19.8981 34.8148 15.7593 31.8704 11.9444 28.0556C8.12963 24.2407 5.18519 20.1019 3.11111 15.6389C1.03704 11.1759 0 6.7963 0 2.5C0 1.7857 0.238092 1.19046 0.714278 0.714278C1.19046 0.238092 1.7857 0 2.5 0H10.2778C10.7963 0 11.2407 0.185185 11.6111 0.555556C11.9815 0.925926 12.2407 1.38889 12.3889 1.94444L13.8849 8.9245C13.9616 9.45632 13.9537 9.93519 13.8611 10.3611C13.7685 10.787 13.5698 11.1523 13.2651 11.457L7.72222 17.0556C8.68519 18.6852 9.7037 20.2037 10.7778 21.6111C11.8519 23.0185 13.037 24.3519 14.3333 25.6111C15.7037 27.0185 17.1481 28.3056 18.6667 29.4722C20.1852 30.6389 21.7778 31.6667 23.4444 32.5556L28.7222 27.1111C29.0926 26.7037 29.5213 26.4259 30.0084 26.2778C30.4955 26.1296 30.9742 26.0926 31.4444 26.1667L38.0556 27.6111C38.6111 27.7593 39.0741 28.0564 39.4444 28.5024C39.8148 28.9485 40 29.4477 40 30V37.5C40 38.2143 39.7619 38.8095 39.2857 39.2857C38.8095 39.7619 38.2143 40 37.5 40Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelColor4);
export default __webpack_public_path__ + "static/media/tel_color4.196c18f0922d1055085da445c8507424.svg";
export { ForwardRef as ReactComponent };